import { ReactElement } from "react"

import AmendEbDeviceForm from "../../../../components/devices/lct/eb/amendEbDeviceForm"
import ContinueEbDeviceAmendmentProvider from "../../../../components/devices/lct/eb/providers/continueEbDeviceAmendmentProvider"

const ContinueEbDraftDeviceAmendment = (): ReactElement => (
    <ContinueEbDeviceAmendmentProvider>
        <AmendEbDeviceForm />
    </ContinueEbDeviceAmendmentProvider>
)

export default ContinueEbDraftDeviceAmendment
